
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/heiskort",
      function () {
        return require("private-next-pages/[region]/[resort]/heiskort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/heiskort"])
      });
    }
  